import { Box, Modal } from '@mui/material'
import React from 'react'
import { CrossIcon } from '../../utils/functions/Icons'
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../utils/store/AllReducers';
import { handleCloseLogoutModal, handleLogout } from '../../utils/store/auth/AuthSlice';
import { useNavigate } from 'react-router-dom';

const LogoutModal = () => {
    const dispatch = useDispatch();
    const { openLogoutModal } = useSelector((state: RootState) => state.auth)
    const navigate = useNavigate();

    const handleClose = () => {
        dispatch(handleCloseLogoutModal())
    }
    const confirmLogout =() =>{
        dispatch(handleLogout())
        navigate("/login")
    }
    return (
        <Modal
            open={openLogoutModal}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box sx={{ width: 500 }}  className="CustomModalBox">
                <div className='modalHeader'>
                    <h3>Are you sure, you want to log out?</h3>
                    <CrossIcon onClick={handleClose} />
                </div>
                <div className='modalBody mt-10'>
                    <div className='flex justify-end flex-col sm:flex-row gap-6'>
                        <button className='fillButton w-1/2' onClick={confirmLogout}>Yes</button>
                        <button className='outLineButtonBlack outLineButtonNo w-1/2' onClick={handleClose}>No</button>
                    </div>
                </div>
            </Box>
        </Modal>
    )
}

export default LogoutModal